import { exec } from "@/util/preact-iso";

export type RoutesMap = {
  [routeName: string]: string;
};

export class Router {
  routesMap: RoutesMap = {};
  update: () => void = () => { };

  setupRoutesMap(routesMap: RoutesMap) {
    this.routesMap = routesMap;
  }

  setupUpdate(update: () => void) {
    this.update = update;
  }

  getRoutePathByName(name: string): string | undefined {
    return this.routesMap[name];
  }

  getCurrentRouteName(): string | null | undefined {
    return this.getCurrentRouteLocation()?.name || null;
  }

  getCurrentRouteParameters() {
    return this.getCurrentRouteLocation()?.params || null;
  }

  getCurrentRouteLocation(): { name: string; params: Record<string, string>; path: string; search: string } | null {
    for (const [routeName, path] of Object.entries(this.routesMap)) {
      const matched = exec(location.pathname, path);
      if (matched) {
        return {
          name: routeName,
          params: matched.params,
          path: location.pathname,
          search: location.search,
        };
      }
    }

    return null;
  }

  isHomePage(): boolean {
    return ["home-page-with-lang", "home-page"].includes(this.getCurrentRouteName() || "");
  }

  isB2BPage(): boolean {
    return ["b2b-platform"].includes(this.getCurrentRouteName() || "");
  }

  getRouteParamsFromPath(path: string): string[] {
    const paramsRegex = /[:|\*](\w+)/g;
    const params: string[] = [];
    let match: RegExpExecArray | null;
    while ((match = paramsRegex.exec(path)) !== null) {
      params.push(match[1]);
    }

    return params;
  }

  urlForPath(pathTemplate: string, params: Record<string, string | number>) {
    return pathTemplate.replace(/:([a-zA-Z]+)/g, (_, key) => {
      const value = params[key];
      if (value === undefined) {
        throw new Error(`Missing param: ${key}`);
      }
      return encodeURIComponent(String(value));
    });
  }

  generatePath(template: string, params: any) {
    return template.replace(/:([^/]+)/g, (_, key) => {
      if (!(key in params)) {
        throw new Error(`Missing parameter "${key}" for path "${template}"`);
      }
      return encodeURIComponent(params[key]);
    });
  }
}
